/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { LoggerService } from '../../../modules/shared/services/logger.service';
import { filter, map, tap } from 'rxjs/operators';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';

@Injectable({
    providedIn: 'root',
})
export class NoManualAuthenticationGuard  {
    constructor(private logger: LoggerService, private store: Store, private router: Router) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const isManualNavigation = this.router.navigated || this.router.currentNavigation().id > 1;
        const exceptions = [
            '/auth/forgot',
            '/auth/reset',
            '/auth/confirm',
            '/auth/callback'
        ];
        let hasException = false;
        exceptions.forEach((path) => {
            if (state.url.startsWith(path)) {
                hasException = true;
            }
        });
        return of(isManualNavigation || hasException).pipe(
            tap((allowed) => {
                if (!allowed) {
                    this.store.dispatch(new Navigate(['/']));
                }
            })
        );
    }
}
